const home = {
  hero: {
    eyebrow: 'Vinski Vrh · Miklavž pri Ormožu',
    title: 'Črna Kuhna',
    tagline: 'Iz ognja. Iz Prlekije. Za skupno mizo.',
    lead: '',
    ctaReserve: 'Rezerviraj mizo',
    ctaMenu: 'Poglej jedilnik',
    linksNote: 'Za več informacij kliknite spodnje povezave',
    photoLabel: 'Mesto za naslovno fotografijo — krušna peč oziroma priprava hrane',
    scrollHint: 'Pomakni se',
  },
  fire: {
    label: 'Ogenj',
    title: 'Kuhanje, ki se začne pri ognju',
    text: 'V središču naše kuhinje je krušna peč. Toplina žerjavice, počasno pečenje in vonj, ki napolni prostor — vse, kar pride na mizo, nosi sled ognja.',
    photoLabel: 'Fotografija — ogenj v krušni peči',
  },
  grill: {
    label: 'Žar',
    title: 'Kuhanje na odprtem ognju',
    text: 'Nekatere jedi ne potrebujejo nič drugega kot ogenj, žerjavico in potrpežljivost. Na odprtem žaru se meso in zelenjava počasi pečeta, dim pa jima doda zadnjo plast okusa.',
    photoLabel: 'Fotografija — žar z odprtim ognjem',
  },
  seasonal: {
    label: 'Letni časi',
    title: 'Kar da letni čas',
    text: 'Kuhinja sledi letnim časom in prleški zemlji. Sestavine izbiramo takrat, ko so najboljše, zato se jedilnik skozi leto spreminja.',
    photoLabel: 'Fotografija — sezonske sestavine',
  },
  dishes: {
    label: 'Z mize',
    title: 'Izbrane jedi',
    text: 'Jedi, ki jih pripravljamo, rastejo iz ognja, sezone in domače tradicije. Povemo vam natanko, kaj je na krožniku — brez izmišljotin.',
    ctaMenu: 'Poglej jedilnik',
    note: 'Sezonski jedilnik se spreminja. Aktualno ponudbo preverite po telefonu.',
    photoLabel: 'Fotografija — jed z mize',
  },
  wines: {
    label: 'V kozarcu',
    title: 'Hišna vina Glavinič',
    text: 'Ob jedi se najbolje pije vino, ki raste tik ob njej. Zato gostimo hišna vina Glavinič iz prleških vinogradov.',
    ctaWines: 'Več o vinih',
    photoLabel: 'Fotografija — kozarec vina oziroma vinogradi',
  },
  space: {
    label: 'Prostor',
    title: 'Prostor in doživetje',
    text: 'Gostoljuben prostor, kjer se miza deli, kozarec nalije in dan ustavi. Prleška krajina je del vsakega obiska.',
    photoLabel: 'Fotografija — prostor oziroma notranjost',
    feature1: 'Miza, ki se deli med goste',
    feature2: 'Kozarec, ki se nalije ob pravi jedi',
    feature3: 'Čas, ki se ustavi ob pogovoru',
  },
  galleryPreview: {
    label: 'Utrinki',
    title: 'Z naše mize in iz našega prostora',
    text: 'Nekaj utrinkov iz Črne Kuhne — ogenj, jedi, prostor in vino. Več fotografij najdete v galeriji.',
    cta: 'Poglej galerijo',
  },
  location: {
    label: 'Lokacija',
    title: 'Med vinogradi Prlekije',
    text: 'Najdete nas na Vinskem Vrhu pri Miklavžu pri Ormožu, sredi gričev in vinogradov. Gumb spodaj odpre navigacijo do nas.',
    ctaDirections: 'Odpri navigacijo',
    photoLabel: 'Fotografija — vinogradi oziroma pokrajina',
  },
  hours: {
    label: 'Zimski odpiralni čas',
    title: 'Zimski odpiralni čas',
    note: 'Za večje skupine in posebne priložnosti nas pokličite.',
    rows: [
      { day: 'Ponedeljek–četrtek', time: 'Zaprto' },
      { day: 'Petek–sobota', time: '12.00–22.00' },
      { day: 'Nedelja', time: '12.00–17.00' },
    ],
  },
  reserve: {
    label: 'Rezervacija',
    title: 'Pridite za skupno mizo',
    text: 'Mizo rezervirate hitro — prek spleta, po telefonu ali e-pošti. Veselimo se vašega obiska.',
    cta: 'Rezerviraj mizo',
    callLabel: 'Telefon',
    emailLabel: 'E-pošta',
  },
};

export default { home };